import { useEffect, useState } from 'react';

import { useUIResourcePool } from '@/ducks/common/resources';
import { selectPagePrevPath } from '@/ducks/page/selectors';
import { selectCelebrationsIsFlowActive } from '@/ducks/programs/celebrations/selectors';
import { env } from '@/environment';
import { useAppSelector } from '@/store';

import { BackSearchButton } from '.';

const UI_RESOURCE_POOL = {
  celebrationsButtonText: 'BackToSearch.Celebrations.CTA',
  celebrationsButtonTextShort: 'BackToSearchShort.Celebrations.CTA',
  defaultButtonText: 'BackToSearch.CTA',
  defaultButtonTextShort: 'BackToSearchShort.CTA',
} as const;

const CelebrationBackSearchButton = (props: React.ComponentProps<'button'>) => {
  const prevPath = useAppSelector(selectPagePrevPath);
  const isCelebrationActive = useAppSelector(selectCelebrationsIsFlowActive);
  const { celebrationsButtonText, celebrationsButtonTextShort, defaultButtonText, defaultButtonTextShort } =
    useUIResourcePool(UI_RESOURCE_POOL);

  const [referrer, setReferrer] = useState('');
  useEffect(() => {
    setReferrer(document?.referrer);
  }, []);

  const showBackSearch = prevPath || referrer.includes(env.CONTEXT);
  if (!showBackSearch) return null;

  const buttonText = isCelebrationActive ? celebrationsButtonText : defaultButtonText;
  const buttonTextShort = isCelebrationActive ? celebrationsButtonTextShort : defaultButtonTextShort;

  return <BackSearchButton buttonText={buttonText} buttonTextShort={buttonTextShort} {...props} />;
};

export default CelebrationBackSearchButton;
